import React, { useState, useEffect } from "react";
import fileDownload from "js-file-download";
import { setNotification } from "../../../helpers/notification";
import { useSelector, useDispatch } from "react-redux";
import ComboBox from "../../../components/ComboBox";
import { Input, Select } from "../../../components/Inputs";
import {
  getRegistrationCommitmentStatusRequest,
  getRegistrationGeneralCommitmentStatusRequest,
} from "../../../redux/actions/organizations";
import { plantStatuses } from "../../../constants/selects";
import { API_EXPORT } from "../../../helpers/api";

import { getStationRequested } from "../../../redux/actions/stations";
import Pill from "../../../components/Pill";
import moment from "moment";
import Button from "../../../components/Button";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import Loading from "../../../components/Loading";

export default function YEKGCommitmentStatus({ t }) {
  const dispatch = useDispatch();
  // const { loading } = useSelector((state) => state.organizations);
  let selectedOrganization = useSelector(
    (state) => state.organizations.selectedOrganization
  );
  const registrationGeneralCommitmentStatus = useSelector(
    (state) => state.organizations.registrationGeneralCommitmentStatus
  );
  const commintmentStatusLoading = useSelector(
    (state) => state.organizations.commintmentStatusLoading
  );

  const registrationCommitmentStatusList = useSelector(
    (state) => state.organizations.registrationCommitmentStatusList
  );
  const totalPageCount = useSelector(
    (state) => state.organizations.totalPageCount
  );

  const stations = useSelector((state) => state.stations.list);
  const [exportLoading, setExportLoading] = useState(false);

  const [activePage, setActivePage] = useState(0);
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [date, setDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [plants, setPlants] = useState([]);

  const [selectedStation, setSelectedStation] = useState("-");
  const [plantStatus, setPlantStatus] = useState();
  const selectStatus = plantStatuses(t);

  const commitmentColumns = [
    {
      name: t("pages.default.YEKGParticipation.table.organizationID"),
      selector: "organizationId",
      sortable: true,
      cell: (row) => row?.organizationId ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      cell: (row) => row?.organizationName ?? "-",
    },
    {
      name: t("pages.default.organisationRegistration.table.stationId"),
      selector: "plantId",
      sortable: true,
      cell: (row) => row?.plantId ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.stationEic"),
      selector: "plantEic",
      sortable: true,
      cell: (row) => row?.plantEic ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.stationStatus"),
      selector: "stationStatus",
      sortable: true,
      cell: (row) => row?.stationStatus ?? "-",
    },
    {
      name: t("pages.default.organisationRegistration.table.stationName"),
      selector: "plantName",
      sortable: true,
      cell: (row) => row?.plantName ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.licenseNumber"),
      selector: "licenseNumber",
      sortable: true,
      cell: (row) => row?.licenseNumber ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.licenseType"),
      selector: "licenseType",
      sortable: true,
      cell: (row) => row?.licenseType ?? "-",
    },
    {
      name: t("pages.default.organisationRegistration.table.installedPower"),
      selector: "installedPower",
      sortable: true,
      cell: (row) => row?.installedPower ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.operatingPower"),
      selector: "operatingPower",
      sortable: true,
      cell: (row) => row?.operatingPower ?? "-",
    },
    {
      name: t("pages.default.organisationRegistration.table.sourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => row?.resourceType ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.technologyType"),
      selector: "stationTechType",
      sortable: true,
      cell: (row) => row?.stationTechType ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.yekdemStatus"),
      selector: "yekdemStatus",
      sortable: true,
      cell: (row) => {
        return row?.yekdemStatus ? (
          <Pill type="success" label={t("ui.default.codes.ACTIVE")} />
        ) : (
          <Pill type="important" label={t("ui.default.codes.PASSIVE")} />
        );
      },
    },
    {
      name: t("pages.default.YEKGParticipation.table.yekgCommitmentStatus"),
      selector: "yekgCommitmentStatus",
      sortable: true,
      cell: (row) => {
        return row?.yekgCommitmentStatus ? (
          <Pill type="success" label={t("ui.default.codes.ACTIVE")} />
        ) : (
          <Pill type="important" label={t("ui.default.codes.PASSIVE")} />
        );
      },
    },
    {
      name: t("pages.default.YEKGParticipation.table.stationCity"),
      selector: "stationCity",
      sortable: true,
      cell: (row) => row?.stationCity ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.stationDistrict"),
      selector: "stationDistrict",
      sortable: true,
      cell: (row) => row?.stationDistrict ?? "-",
    },
    {
      name: t("pages.default.YEKGParticipation.table.statusChangeDate"),
      selector: "transactionDate",
      sortable: true,
      cell: (row) => moment(row?.transactionDate).format("DD/MM/YYYY"),
    },
  ];
  // Get stations for selected organization
  useEffect(() => {
    filterRegisterGeneralCommitmentStatus();
    getRegistrationGeneralCommitmentStatus();
  }, []);

  useEffect(() => {
    if (selectedOrganization?.organizationId) {
      dispatch(getStationRequested(selectedOrganization?.organizationId));
    }
  }, [selectedOrganization?.organizationId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (stations) {
      let res = stations ?? [];
      let stationList = res?.reduce(
        (acc, value) => {
          acc.push({
            value: value.stationId,
            name: value.stationName,
          });
          return acc;
        },
        [{ value: "-", name: t("ui.default.codes.selectPlant") }]
      );
      setPlants(stationList);
    }
  }, [stations]);

  const getRegistrationGeneralCommitmentStatus = () => {
    dispatch(getRegistrationGeneralCommitmentStatusRequest({}));
  };

  const downloadCommitmentStatus = async () => {
    setExportLoading(true);
    try {
      const res = await API_EXPORT("/commitment-status/export/excel", {
        date: date ? moment(date).format("DD-MM-YYYY") : null,
        organizationId: selectedOrganization
          ? selectedOrganization.organizationId
            ? selectedOrganization.organizationId
            : null
          : null,
        plantId:
          selectedStation !== "-" && parseInt(selectedStation)
            ? parseInt(selectedStation)
            : null,
        yekgCommitmentStatus: plantStatus ?? null,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setExportLoading(false);
    }
  };

  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    let params = {
      date: date ? moment(date).format("DD-MM-YYYY") : null,
      organizationId: selectedOrganization
        ? selectedOrganization.organizationId
        : null,
      plantId:
        selectedStation !== "-" && parseInt(selectedStation)
          ? parseInt(selectedStation)
          : null,
      yekgCommitmentStatus: plantStatus ?? null,
    };
    dispatch(
      getRegistrationCommitmentStatusRequest({
        ...params,
        // organizationId: selectedOrganization?.organizationId ?? null,
        // date: date ? moment(date).format("DD-MM-YYYY") : null,
        // endDate: endDate ? moment(endDate).format("DD-MM-YYYY") : null,
        page: activePage,
        selector: selector,
        direction: direction,
      })
    );
  };

  const filterRegisterGeneralCommitmentStatus = () => {
    setDate(date ? date : null);
    setEndDate(endDate ? endDate : null);
    if (selectedOrganization && Object.keys(selectedOrganization).length === 0)
      selectedOrganization = undefined;
    let params = {
      date: date ? moment(date).format("DD-MM-YYYY") : null,
      organizationId: selectedOrganization
        ? selectedOrganization.organizationId
        : null,
      plantId:
        selectedStation !== "-" && parseInt(selectedStation)
          ? parseInt(selectedStation)
          : null,
      yekgCommitmentStatus: plantStatus ?? null,
    };
    dispatch(getRegistrationCommitmentStatusRequest({ ...params }));
  };
  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.YEKGCommitmentStatus.title")}
      </h5>
      <div className="km__p--card">
        <p
          style={{
            marginTop: "20px",
            border: "1px solid #dfe1e6",
            padding: "30px 10px",
            textAlign: "center",
          }}
        >
          {registrationGeneralCommitmentStatus?.titleOfProductionPlantWithDate}
        </p>
      </div>

      <div className="km__p--card">
        <div className="km__p--market-results-contracts-header">
          <p className="km__u--text_title">
            {t("pages.default.YEKGCommitmentStatus.title")}
          </p>
          <div className="km__p--market-results-contracts-header-filter">
            <Input
              type="date"
              placeholder={t("pages.default.offerOperations.table.date")}
              // min={
              //   new Date(moment(date).add(1, "days").format("MM-DD-YYYY"))
              // }
              value={date}
              onChange={(e) => setDate(e.target.value)}
              id="ba-history-date"
            />
            <ComboBox t={t} />
            <Select
              options={plants}
              name="plant"
              onChange={(e) => setSelectedStation(e.target.value)}
            />
            <Select
              options={selectStatus}
              name="plantStatus"
              onChange={(e) => setPlantStatus(e.target.value)}
            />

            {/* <Input
              type="month"
              placement="bottom-end"
              placeholder={t("pages.default.marketResults.sessionPeriod")}
              name="period"
              value={filter.period}
              // onChange={filterChange}
            /> */}
            <Button
              label={t("ui.default.filter")}
              onClick={filterRegisterGeneralCommitmentStatus}
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              suffixIcon="download"
              onClick={downloadCommitmentStatus}
              disabled={exportLoading}
              id="c-download"
            />
          </div>
        </div>
        {!commintmentStatusLoading && (
          <DataTableServerSideRendering
            columns={commitmentColumns}
            data={registrationCommitmentStatusList}
            rowKey="id"
            sortedColumn={sortedColumn}
            setSortedColumn={setSortedColumn}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            pagination
            // rowSelection={(row) => contractSelection(row)}
            // isRowSelected={(row) => contractRowSelected(row)}
            // selectableRow
            activePage={activePage}
            totalPageCount={totalPageCount}
            handleFetchData={handleClick}
          />
        )}
        {commintmentStatusLoading && (
          <Loading text={t("pages.default.YEKGCommitmentStatus.title")} />
        )}
      </div>
    </>
  );
}
